var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgULockAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#FFF8CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14H26C26.2652 14 26.5196 14.1054 26.7071 14.2929C26.8946 14.4804 27 14.7348 27 15V27C27 27.2652 26.8946 27.5196 26.7071 27.7071C26.5196 27.8946 26.2652 28 26 28H10C9.73478 28 9.48043 27.8946 9.29289 27.7071C9.10536 27.5196 9 27.2652 9 27V15C9 14.7348 9.10536 14.4804 9.29289 14.2929C9.48043 14.1054 9.73478 14 10 14H12V13C12 11.4087 12.6321 9.88258 13.7574 8.75736C14.8826 7.63214 16.4087 7 18 7C19.5913 7 21.1174 7.63214 22.2426 8.75736C23.3679 9.88258 24 11.4087 24 13V14ZM22 14V13C22 11.9391 21.5786 10.9217 20.8284 10.1716C20.0783 9.42143 19.0609 9 18 9C16.9391 9 15.9217 9.42143 15.1716 10.1716C14.4214 10.9217 14 11.9391 14 13V14H22ZM17 20V22H19V20H17ZM13 20V22H15V20H13ZM21 20V22H23V20H21Z",
    fill: "url(#paint0_linear_458_364)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_364",
    x1: 27,
    y1: 17.5981,
    x2: 9.00299,
    y2: 17.8302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2800D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULockAlt);
export default __webpack_public_path__ + "static/media/u_lock-alt.2c824d58049a8c363ba2d7fa7feae5e4.svg";
export { ForwardRef as ReactComponent };